import cookie from 'js-cookie';

/* porovnavac produktu - prepnuti mezi zobrazenim vseho a pouze rozdilnych radku */
export default (props, e) => {		
	const {
		parent,
	} = props;
	const target = document.querySelector(parent);

	cookie.set('PRODUCT_COMPARISON_SHOW_DIFFERENT_ONLY', e.target.checked, { expires: 7, path: '/' });
	target.classList.toggle('show-different-only');
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/eshopComparisonShowDifferentLines.js